import { render, staticRenderFns } from "./ListaModelos.vue?vue&type=template&id=2ef49d5e"
import script from "./ListaModelos.vue?vue&type=script&lang=js"
export * from "./ListaModelos.vue?vue&type=script&lang=js"
import style0 from "./ListaModelos.vue?vue&type=style&index=0&id=2ef49d5e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports